export default __webpack_public_path__ + "static/media/candy.028c6af7.svg";